import React from 'react';
import { Box, Stack } from '@mui/material';


interface Props {
    stepNumber?: number;
    totalSteps: number;
    onClick?: (stepNumber: number) => void;

}

export const StepsProgress: React.FC<Props> = (props) => {
  const { stepNumber = 1, totalSteps, onClick } = props;

  const isCurrentStep = (index: number) => index + 1 === stepNumber;
  const isCompletedStep = (index: number) => index + 1 < stepNumber;

  return (
    <Stack
      direction="row"
      gap="5px"
      sx={{
        width: '100%',
      }}
    >
      {Array.from({ length: totalSteps }, (_, index) => (
        <Box
          onClick={() => onClick && onClick(index + 1)}
          sx={{
            flexGrow: 1,
            marginRight: '2px',
            display: 'inline-block',
          }}
          key={index}
        >
          <Box
            sx={{
              height: '4px',
              width: '100%',
              backgroundColor: 'primary.main',
              opacity: isCurrentStep(index) || isCompletedStep(index) ? 1: 0.2,
              borderRadius: '25px',
            }}
          />
        </Box>
      ))}
    </Stack>
  );
};
